import { StorageKeys } from "../../constants"

export const onKeyboardSubmit =
  (onSubmit?: (event: any) => void) => (event: any) => {
    if (event.code === "Space" || event.code === "Enter") {
      event.preventDefault()
      onSubmit?.(event)
    }
  }

export const combine =
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type


    (...fns: Function[]) =>
    (value: any) =>
      fns.forEach(fn => fn && fn(value))

export const combineListeners = (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  listeners: Record<string, Function>,
  props: Record<string, any>
): Record<string, any> => {
  const combinedListeners: Record<string, any> = {}

  for (const listener in listeners) {
    if (Object.prototype.hasOwnProperty.call(listeners, listener)) {
      combinedListeners[listener] = combine(
        listeners[listener],
        props[listener]
      )
    }
  }

  return combinedListeners
}

export const resetCalculatorData = () =>
  sessionStorage.setItem(StorageKeys.Calculator, null)
